/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * IntakeApp
 * OpenAPI spec version: v1
 */

export type AllergenTypes = typeof AllergenTypes[keyof typeof AllergenTypes];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AllergenTypes = {
  AllergenClass: 'AllergenClass',
  ScreenableIngredient: 'ScreenableIngredient',
  RoutedDoseFormDrugs: 'RoutedDoseFormDrugs',
  FoodAndEnvironmentalAllergens: 'FoodAndEnvironmentalAllergens',
} as const;
